<template>
  <nav class="header">
    <router-link v-if="!isLogged" class="navbar-brand padded" :to="{name: 'home'}">Item Manager</router-link>
    <router-link v-if="isLogged" class="navbar-brand" :to="{name: 'loader'}">
      <div class="user-picture">
        <img :src="profilePicturePath">
      </div>
    </router-link>
    <account-selector></account-selector>

    <div class="spacer"></div>
    <div class="ordering padded" v-show="isLogged">
      <i class="material-icons">sort</i>
      <select v-model="ordering" ref="orderingSelect">
        <option v-for="ordering in allOrderings" :value="ordering">{{ ordering }}</option>
      </select>
    </div>
    <a class="filters padded only-small" @click="toggleFilter()" v-if="isLogged">
      <span class="label"></span>
      <i class="material-icons">{{ $route.name === 'filter' ? 'arrow_back' : 'search' }}</i>
    </a>

    <a class="padded" @click="handleRefresh()" v-if="isLogged">
      <span class="label">Reload</span>
      <i class="material-icons">refresh</i>
    </a>
    <a class="login padded" v-show="!isLogged" @click="handleLogin()">
      <span>Authorize with Bungie.net</span>
      <i class="material-icons">lock_open</i>
    </a>
    <a v-if="isLogged" class="padded" @click="$router.push({name: 'tools'})">
      <span class="label">Tools</span>
      <i class="material-icons">build</i>
    </a>
    <a class="padded" @click="$router.push({name: 'settings'})">
      <span class="label">Settings</span>
      <i class="material-icons">settings</i>
    </a>
    <a @click="$router.push({name: 'settings'})" class="padded only-big" v-show="!user">
      <i class="material-icons">cloud_off</i>
    </a>
    <span class="padded only-big" v-show="user">
      <i class="material-icons">cloud</i>
    </span>
    <a class="login padded" v-show="isLogged" @click="handleLogout()">
      <span class="label">Logout</span>
      <i class="material-icons">exit_to_app</i>
    </a>
  </nav>
</template>

<script>
  import { orderings } from '@/utils/orderings'
  import { mapGetters, mapState } from 'vuex'
  import AccountSelector from '@/components/AccountSelector'

  export default {
    name: 'nav-bar',
    data () {
      return {}
    },
    computed: {
      ...mapGetters('auth', ['isLogged']),
      ...mapState('firebaseAuth', ['user']),
      profilePicturePath () {
        if (this.$store.state.destiny.currentUser) {
          return 'https://www.bungie.net' + this.$store.state.destiny.currentUser.profilePicturePath
        }
        return false
      },
      username () {
        if (this.$store.state.currentUser) {
          return this.$store.state.currentUser.displayName
        }
      },
      ordering: {
        get () {
          return this.$store.state.destiny.filters.ordering
        },
        set (value) {
          this.$store.commit('destiny/filters/setOrdering', {ordering: value})
        }
      },
      allOrderings: {
        get () {
          return Object.keys(orderings)
        }
      }
    },
    methods: {
      handleLogin () {
        this.$store.dispatch('auth/login')
      },
      handleLogout () {
        this.$store.dispatch('auth/logout').then(() => this.$router.push({name: 'home'}))
      },
      handleRefresh () {
        this.$store.dispatch('destiny/profile/reload').then(reloadCommit => {
          reloadCommit()
          this.$store.commit('queue/setCurrentActionMessage', {message: ''})
        })
      },
      toggleFilter () {
        if (this.$route.name === 'filter') {
          this.$router.back()
        } else {
          this.$router.push({'name': 'filter'})
        }
      }
    },
    components: {
      AccountSelector
    }
  }
</script>

<style lang="scss">
  @import "../styles/settings";

  nav.header {
    overflow: hidden;
    flex-basis: 3rem;
    background-color: $background;

    color: rgba(245, 245, 245, 0.5);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    position: relative;
    z-index: 3;

    a {
      transition: color 0.2s ease-in-out;
      text-transform: uppercase;
    }
    > .padded {
      padding: 1rem;
      white-space: nowrap;
    }

    .user-picture {
      padding: .25rem 0.5rem 0 1rem;
    }

    .user-picture img {
      height: 2.5rem;
    }

    .user-name {
      padding: 1rem 0.5rem;
    }

    .login {
    }

    .material-icons {
      font-size: 1rem;
      vertical-align: text-bottom;
    }

    .spacer {
      flex-grow: 1;
    }

    .padded {

    }
    @media #{$media-phone} {
      .label {
        display: none;
      }
      .ordering {
        .material-icons {
          position: absolute;
          z-index: 1;
          &:hover {
            color: rgba(245, 245, 245, 1);
          }
        }
        select {
          position: relative;
          width: 30px;
          z-index: 2;
          text-indent: 30px;
        }
      }

    }
  }


</style>



// WEBPACK FOOTER //
// NavBar.vue?ee765c78